import useInView from "../hooks/useInView";

/**
 * Wraps children in a fade+rise on-scroll reveal.
 * Usage: <Reveal delay={1}> <div/> </Reveal>
 */
export default function Reveal({ children, delay = 0, className = "", as: Tag = "div" }) {
  const [ref, visible] = useInView({ threshold: 0.12 });
  const delayCls = delay ? ` delay-${delay}` : "";
  return (
    <Tag ref={ref} className={`reveal${visible ? " is-visible" : ""}${delayCls} ${className}`}>
      {children}
    </Tag>
  );
}
